import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class ReactCrashLog extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'ReactCrashLog';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.reactCrashLog, payload);
    }

    //Parse successful response
    onSuccess() {
        this.dispatch(Actions.getUserData());
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {

    }
}


export default ReactCrashLog;